// extracted by mini-css-extract-plugin
export default {"table":"src-pages-SalesCannelVersion-SalesChannelLegal-LegalPageList-css-module__table--OeDLS"};